import React, { ReactNode } from 'react';
import styles from './Modal.module.scss';
import cx from 'classnames';
import Button from '../Button/Button';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { translate } from '../../utility/messageTranslator/translate';

type Props = {
  onConfirm?: () => void;
  onClose?: () => void;
  isLoading?: boolean;
  isOpen: boolean | any;
  explanationText?: string | undefined;
  title?: string;
  children?: ReactNode;
  className?: string;
  isFooterHidden?: boolean;
  isBig?: boolean;
};

const Modal = ({
  isOpen,
  onConfirm,
  onClose,
  explanationText,
  title,
  isLoading,
  children,
  className,
  isFooterHidden,
  isBig,
}: Props) => {
  const intl = useIntl();

  const isTitleVisible = !isBig;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={cx(
        styles.confirmationModal,
        {
          [styles.isBig]: isBig,
        },
        className,
      )}
    >
      {isTitleVisible && (
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      )}
      <DialogContent>
        {explanationText && (
          <DialogContentText id="alert-dialog-description">
            {explanationText}
          </DialogContentText>
        )}
        {children}
      </DialogContent>
      {!isFooterHidden && onConfirm && (
        <DialogActions>
          <Button isConfirmationButton onClick={onClose}>
            {translate(intl, 'MODAL.CANCEL', 'Cancel')}
          </Button>
          <Button
            isConfirmationButton
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {translate(intl, 'MODAL.CONFIRM', 'Confirm')}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default Modal;
